import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductimageService } from '../../../../_services/admin/productimage.service';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.scss']
})
export class ProductImagesComponent implements OnInit {

  addProductImageForm: FormGroup;
  isAddProductImageFormSubmitted = false;
  imageurl = environment.productImageUrl;
  fileToUpload: File = null;
  productImagesList: any[] = [];
  productId: number = 0;

  constructor(private formBuilder: FormBuilder,
    private myTitle: Title,
    private router: Router,
    private snackBar: MatSnackBar,
    private productimageService: ProductimageService,
    private route: ActivatedRoute) {

    this.route.params.subscribe(params => {
      if (params['id']) {
        this.addProductImageForm = this.formBuilder.group({
          'productId': [null],
          'title': [null, Validators.required]
        });
        this.productId = params['id'];
        this.getProductImages(this.productId);
        this.addProductImageForm.controls['productId'].setValue(params['id']);
      }
    });

  }

  ngOnInit() {
    this.myTitle.setTitle('Product Images | ' + environment.commonTitle);
  }

  getProductImages(productId: any) {
    this.productimageService.getProductImages(productId).subscribe(result => {
      if (result.data) {
        this.productImagesList = result.data;
      }
    });
  }

  addProductImage() {
    if (this.addProductImageForm.valid) {
      if (!isNullOrUndefined(this.fileToUpload)) {
        const objdata = {
          ProductID: this.addProductImageForm.value.productId,
          Title: this.addProductImageForm.value.title,
          productImgObj: this.fileToUpload,
        };
        this.productimageService.addProductImages(objdata).subscribe(result => {
          if (result.data) {
            this.getProductImages(this.productId);
            this.openSnackBar('Product Image saved successfully.', 'Category!');
            this.addProductImageForm.reset();
            this.fileToUpload = null;
          }
        }, error => {
          debugger
          this.openSnackBar(error.error, 'Failed to save product image');
        });
      } else {
        this.openSnackBar('Please select image.', 'Info!');
      }
    }
  }

  deleteProductImage(id: number) {
    Swal({
      title: 'Are you sure you want to remove image?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      focusConfirm: false
    }).then((res) => {
      if (res.value) {
        this.productimageService.deleteProductImage(id).subscribe(result => {
          if (result.data) {
            this.openSnackBar('Product image deleted succcessfully.', 'Success');
            this.getProductImages(this.productId);
          }
        });
      } else if (res.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  reditectProductList() {
    this.router.navigate(['/secure/home/product/products']);
  }

}
